import { render, staticRenderFns } from "./ComposeMail.vue?vue&type=template&id=7241a2bc&scoped=true"
import script from "./ComposeMail.vue?vue&type=script&lang=js"
export * from "./ComposeMail.vue?vue&type=script&lang=js"
import style0 from "./ComposeMail.vue?vue&type=style&index=0&id=7241a2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241a2bc",
  null
  
)

export default component.exports